import { Injectable, inject } from '@angular/core';

import { mergeSubmittedFields } from 'app/home/create-quote/form-locking/form-lock.util';
import { QuoteDraftStore } from 'app/home/global-store/quote-draft';

@Injectable({
  providedIn: 'root',
})
export class FormLockService {
  private quoteDraftStore = inject(QuoteDraftStore);

  markFieldsAsSubmitted(fields: string[], formKey: string): void {
    const currentSubmittedFields = this.quoteDraftStore.submittedFields();

    this.quoteDraftStore.patchStore({
      submittedFields: mergeSubmittedFields(currentSubmittedFields, formKey, fields),
    });
  }

  isFieldSubmitted(fieldName: string, formKey: string): boolean {
    return this.quoteDraftStore.submittedFields()[formKey]?.[fieldName] ?? false;
  }
}
